// @flow
import values from 'ramda/es/values';
import map from 'ramda/es/map';
import pipe from 'ramda/es/pipe';
import prop from 'ramda/es/prop';
import filter from 'ramda/es/filter';
import complement from 'ramda/es/complement';
import isEmpty from 'ramda/es/isEmpty';
import identity from 'ramda/es/identity';
import flatten from 'ramda/es/flatten';
import sort from 'ramda/es/sort';
import ascend from 'ramda/es/ascend';

import type { Params, MonthMarks } from 'app/dataTypes/MonthMarks.types';
import type { Discipline } from 'app/dataTypes/Discipline.types';

import type { Request } from '../../../index';


const dateFormatApi: 'YYYY-MM-DD' = 'YYYY-MM-DD';

type ParamsApi = {
  klass_id: number,
  student_id: number,
  date: string,
}

type ResultApi = {
  [discipline_id: string]: {
    title: string,
    discipline_id: number,
    marks: {
      [day: string]: Array<Array<{
        value: string,
        description: string,
      }>>,
    }
  },
}

export const convertParams = (params: Params): [ParamsApi, null] => {
  const { studentId, klassId, date } = params;

  return [{
    student_id: parseInt(studentId, 10),
    klass_id: parseInt(klassId, 10),
    date: date.getString(dateFormatApi),
  }, null];
};

export const convertResult = (res: ResultApi): [Array<Discipline>, MonthMarks] => {
  const disciplines = pipe(
    values,
    map(({ discipline_id: id, title }) => ({
      id: String(id),
      title: title || '???',
    })),
    sort(ascend(prop('title'))),
  )(res);

  const marks = map(pipe(
    prop('marks'),
    filter(complement(isEmpty)),
    map(pipe(
      flatten,
      map(({ value, description }) => (value || value === 0 ? {
        value: String(value),
        description: description || null,
      } : null)),
      filter(identity),
    )),
  ), res);

  return [disciplines, marks];
};

export const GET_GRADES_MONTH: Request<
  Params,
  [Array<Discipline>, MonthMarks],
  void
> = [
  'cabinet/dnevnik/grades/month',
  'get',
  ['data', 'marks'],
];
